import { Button, Card, CardBody, CardFooter, Select, SelectItem } from "@nextui-org/react"
import { ENUM_INPUT_TYPE, apiRoute, linksUrl } from "../../constants/enum"
import { useEffect, useState } from "react"
import NextInputBox from "../../components/InputBox"
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks"
import { useSelector } from "react-redux"
import { toast } from "react-toastify"


const Broker = () => {
    const { compCode } = useSelector((state) => state.company)
    const { user } = useSelector((state) => state.auth)
    const { partyAcId } = useSelector((state) => state.account)
    let [isUpdate, setIsUpdate] = useState(false);

    const { data: itemBroker = [] } = useFetchWithBody({
        url: apiRoute.account.fetchAcByType,
        queryKey: "getAcTypeBroker",
        inputData: {
            comp_code: compCode.join(","),
            ac_type: "Broker"
        }
    })

    const onSuccessGetBroker = (data) => {
        if (data && data.length > 0) {
            if (data && data.length > 0) {
                setIsUpdate(true);
                setFormData({
                    brokerId: data[0]?.BAc_Id,
                    brokerage: data[0].Bro_Per,
                    brokerageRate: data[0].BRO_RATE_QTY
                })
            }
        }
        else {
            setIsUpdate(false);
        }

    }
    const { data = [], mutate: getBroker } = usePost({
        url: apiRoute.account.fetchBroker,
        queryKey: "getBroker",
        onSuccessTasks: onSuccessGetBroker

    })

    const formField = {
        brokerId: "brokerId",
        brokerage: "brokerage",
        brokerageRate: "brokerageRate",
    }
    const emptyFormField = Object.keys(formField).reduce((acc, key) => {

        if (key == formField.brokerId)
            acc[key] = "";
        else
            acc[key] = 0;
        return acc;
    }, {});

    let [formData, setFormData] = useState({
        ...emptyFormField
    })

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev, [name]: value
        })
        )
    }
    const handleSelectionChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev, [name]: value
        })
        )
    }

    useEffect(() => {
        if (data.length == 0) {
            if (partyAcId && partyAcId !== "") {
                getBroker({
                    data: {
                        comp_code: compCode.join(","),
                        pac_id: partyAcId
                    }
                })

            }
        }
    }, [])

    const inputBoxes = {
        Row1: [
            {
                name: formField.brokerId,
                placeholder: "Broker",
                type: ENUM_INPUT_TYPE.select,
                size: "sm",
                label: "",
                data: itemBroker,
                isrequired: true,
                itemkey: "AC_ID",
                itemvalue: "AC_DESC"
            },

        ],
        Row2:
            [
                {
                    name: formField.brokerage,
                    placeholder: "Brokerage",
                    type: ENUM_INPUT_TYPE.number,
                    size: "sm",
                    label: "",
                    isrequired: false
                },
                {
                    name: formField.brokerageRate,
                    placeholder: "Brokerage Rate",
                    type: ENUM_INPUT_TYPE.number,
                    size: "sm",
                    label: "",
                    isrequired: false
                },
            ]
    }


    const onSuccessTasks = (data) => {
        if (data) {
            toast.success(isUpdate ? "Broker Updated Successfully " : "Broker Assigned Successfully ", {
                position: "top-center"
            })
        }
    }
    const resetValues = () => {
        setFormData({})
    }
    const {isPending, mutate: funInsert } = usePost({
        url: apiRoute.account.addBroker,
        queryKey: "insertBroker",
        onSuccessTasks,
        resetValues
    })
    const handleSubmit = (e) => {

        e.preventDefault();
        funInsert({
            data: {
                datalist: [formData],
                comp_code: compCode.join(","),
                user_id: user.username,
                pac_id: partyAcId,
                rec_status: isUpdate ? 1 : 2
            }

        })
    }

    return (
        <div>
            <Card shadow="sm" radius="sm" className="mb-3 h-full">
                <form onSubmit={handleSubmit}>
                    <CardBody className="p-2">

                        {
                            Object.keys(inputBoxes).map((key, ind) => (
                                <div key={key + ind}>
                                    <div className="flex  items-center gap-2 mb-5" key={ind} >
                                        {inputBoxes[key].map((item, index) => item.type == ENUM_INPUT_TYPE.select ? (
                                            <Select
                                                name={item.name}
                                                size="sm"
                                                label={item.placeholder}
                                                labelPlacement="outside"
                                                placeholder="---select---"
                                                selectionMode="single"
                                                isRequired={item.isrequired}
                                                items={item.data ? item.data : []}
                                                onChange={handleSelectionChange}
                                                selectedKeys={[String(formData[item.name])]}
                                            >
                                                {(list) => {
                                                    return (
                                                        <SelectItem key={list[item.itemkey]}>
                                                            {list[item.itemvalue]}
                                                        </SelectItem>)

                                                }}
                                            </Select>

                                        ) : (
                                            <NextInputBox
                                                placeholder={item.placeholder}
                                                value={formData[item.name]}
                                                required={item.isrequired}
                                                name={item.name}
                                                type={item.type}
                                                size={item.size}
                                                label={item.placeholder}
                                                labelPlacement="outside"
                                                onChange={handleInputChange}
                                            />))}
                                    </div>
                                </div>
                            ))
                        }
                        <div>

                            <CardFooter className="flex justify-center">
                                <Button color="primary" type="submit" isLoading={isPending} >
                                    Submit
                                </Button>

                            </CardFooter>
                        </div>
                    </CardBody>
                </form>

            </Card>
        </div>
    )
}
export default Broker